export const stateCityData = {
    "Andaman and Nicobar Islands": [
        "Bamboo Flat",
        "Barren Island",
        "Garacharma",
        "Havelock",
        "Mayabunder",
        "Neil Island",
        "Port Blair",
        "Rangat"
    ],
    "Andhra Pradesh": [
        "Adoni",
        "Amalapuram",
        "Anakapalle", 
        "Anantapur",
        "Bhimavaram",
        "Chilakaluripet",
        "Chittoor",
        "Eluru",
        "Gooty",
        "Gudivada",
        "Guntur",
        "Hindupur",
        "Kadapa",
        "Kakinada",
        "Kurnool",
        "Machilipatnam",
        "Madanapalle",
        "Nandyal",
        "Narasaraopet",
        "Nellore",
        "Ongole",
        "Proddatur",
        "Rajahmundry",
        "Srikakulam",
        "Tadepalligudem",
        "Tenali",
        "Tirupati",
        "Vijayawada",
        "Visakhapatnam",
        "Vizianagaram"
    ],
    "Arunachal Pradesh": [
        "Aalo",
        "Bomdila",
        "Changlang",
        "Daporijo",
        "Itanagar",
        "Naharlagun",
        "Pasighat",
        "Roing",
        "Tawang",
        "Ziro"
    ],
    "Assam": [
        "Barpeta",
        "Bongaigaon",
        "Dhubri",
        "Dibrugarh",
        "Diphu",
        "Goalpara",
        "Guwahati",
        "Jorhat",
        "Karimganj",
        "Nagaon",
        "Silchar",
        "Tezpur",
        "Tinsukia"
    ],
    "Bihar": [
        "Arrah",
        "Aurangabad",
        "Bagaha",
        "Begusarai",
        "Bettiah",
        "Bhagalpur",
        "Bihar Sharif",
        "Buxar",
        "Chhapra",
        "Darbhanga",
        "Gaya",
        "Hajipur",
        "Katihar",
        "Motihari",
        "Munger",
        "Muzaffarpur",
        "Patna",
        "Purnia",
        "Saharsa",
        "Samastipur",
        "Sitamarhi",
        "Siwan"
    ],
    "Chhattisgarh": [
        "Ambikapur",
        "Bhilai",
        "Bilaspur",
        "Dhamtari",
        "Durg",
        "Jagdalpur",
        "Korba",
        "Raigarh",
        "Raipur",
        "Rajnandgaon"
    ],
    "Delhi": [
        "Central Delhi",
        "East Delhi",
        "New Delhi",
        "North Delhi",
        "North East Delhi",
        "North West Delhi",
        "South Delhi",
        "South West Delhi",
        "West Delhi"
    ],
    "Goa": [
        "Mapusa",
        "Margao",
        "Mormugao",
        "Panaji",
        "Ponda",
        "Vasco da Gama"
    ],
    "Gujarat": [
        "Ahmedabad",
        "Anand",
        "Bhavnagar",
        "Bharuch",
        "Gandhinagar",
        "Jamnagar",
        "Junagadh",
        "Mehsana",
        "Morbi",
        "Nadiad",
        "Navsari",
        "Porbandar",
        "Rajkot",
        "Surat",
        "Vadodara",
        "Vapi",
        "Veraval"
    ],
    "Haryana": [
        "Ambala",
        "Bahadurgarh",
        "Bhiwani",
        "Faridabad",
        "Gurgaon",
        "Hisar",
        "Karnal",
        "Kurukshetra",
        "Panipat",
        "Rewari",
        "Rohtak",
        "Sonipat",
        "Yamunanagar"
    ],
    "Himachal Pradesh": [
        "Bilaspur",
        "Chamba",
        "Dharamshala",
        "Hamirpur",
        "Kangra",
        "Kullu",
        "Mandi",
        "Palampur",
        "Shimla",
        "Solan",
        "Una"
    ],
    "Jharkhand": [
        "Bokaro",
        "Chaibasa",
        "Deoghar",
        "Dhanbad",
        "Dumka",
        "Giridih",
        "Hazaribagh",
        "Jamshedpur",
        "Ranchi"
    ],
    "Karnataka": [
        "Bagalkot",
        "Ballari",
        "Belagavi",
        "Bengaluru",
        "Bidar",
        "Chikkamagaluru",
        "Chitradurga",
        "Davanagere",
        "Hassan",
        "Hubli",
        "Kalaburagi",
        "Mandya",
        "Mangaluru",
        "Mysuru",
        "Raichur",
        "Shivamogga",
        "Tumakuru",
        "Udupi"
    ],
    "Kerala": [
        "Alappuzha",
        // "Changanassery",
        "Ernakulam",
        "Idukki",
        "Kannur",
        "Kasaragod",
        "Kochi",
        "Kollam",
        "Kottayam",
        "Kozhikode",
        "Malappuram",
        "Palakkad",
        "Pathanamthitta",
        "Thiruvananthapuram",
        "Thrissur",
        "Wayanad"
    ],
    "Madhya Pradesh": [
        "Bhopal",
        "Burhanpur",
        "Chhindwara",
        "Dewas",
        "Gwalior",
        "Indore",
        "Jabalpur",
        "Katni",
        "Khandwa",
        "Ratlam",
        "Rewa",
        "Sagar",
        "Satna",
        "Ujjain"
    ],
    "Maharashtra": [
        "Ahmednagar",
        "Akola",
        "Amravati",
        "Aurangabad",
        "Bhiwandi",
        "Chandrapur",
        "Dhule",
        "Jalgaon",
        "Kolhapur",
        "Latur",
        "Mumbai",
        "Nagpur",
        "Nanded",
        "Nashik",
        "Navi Mumbai",
        "Pune",
        "Solapur",
        "Thane",
        "Ulhasnagar"
    ],
    "Odisha": [
        "Balasore",
        "Baripada",
        "Berhampur",
        "Bhadrak",
        "Bhubaneswar",
        "Cuttack",
        "Jeypore",
        "Koraput",
        "Puri",
        "Rourkela",
        "Sambalpur"
    ],
    "Punjab": [
        "Amritsar",
        "Bathinda",
        "Firozpur",
        "Hoshiarpur",
        "Jalandhar",
        "Ludhiana",
        "Moga",
        "Mohali",
        "Pathankot",
        "Patiala",
        "Sangrur"
    ],
    "Rajasthan": [
        "Ajmer",
        "Alwar",
        "Bharatpur",
        "Bhilwara",
        "Bikaner",
        "Churu",
        "Jaipur",
        "Jodhpur",
        "Kota",
        "Pali",
        "Sikar",
        "Udaipur"
    ],
    "Tamil Nadu": [
        "Chennai",
        "Coimbatore",
        "Cuddalore",
        "Dindigul",
        "Erode",
        "Hosur",
        "Kanchipuram",
        "Karur",
        "Madurai",
        "Nagercoil",
        "Salem",
        "Thanjavur",
        "Thoothukudi",
        "Tirunelveli",
        "Tiruppur",
        "Trichy",
        "Vellore"
    ],
    "Telangana": [
        "Adilabad",
        "Hyderabad",
        "Karimnagar",
        "Khammam",
        "Mahbubnagar",
        "Nalgonda",
        "Nizamabad",
        "Ramagundam",
        "Warangal"
    ],
    "Uttar Pradesh": [
        "Agra",
        "Aligarh",
        "Allahabad",
        "Bareilly",
        "Faizabad",
        "Ghaziabad",
        "Gonda",
        "Gorakhpur",
        "Jhansi",
        "Kanpur",
        "Lucknow",
        "Mathura",
        "Meerut",
        "Moradabad",
        "Noida",
        "Rampur",
        "Saharanpur",
        "Sitapur",
        "Varanasi"
    ],
    "West Bengal": [
        "Asansol",
        "Baharampur",
        "Bardhaman",
        "Durgapur",
        "Haldia",
        "Howrah",
        "Kharagpur",
        "Kolkata",
        "Malda",
        "Siliguri"
    ]
}